export default "__VITE_ASSET__9939a423__"